import { Card as MuiCard, CardProps as MuiCardProps, styled } from "@mui/material";

import { Box } from "@/Components/v2/atoms/Box";
import { Typography } from "@/Components/v2/atoms/Typography";

import { colors } from "../../utils/brand-colors";

const StyledCard = styled(MuiCard)(({ theme }) => {
  return {
    padding: "1.5rem",
    borderRadius: "0.5rem",
    border: `1px solid ${theme.palette.mode === "dark" ? colors.grayBorder : colors.dropdownBorder}`,
    boxShadow: "none",
    cursor: "pointer",
    minWidth: "256px",
    minHeight: "140px",
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    justifyContent: "start",
    transition: "background-color 0.2s ease-in-out",
    "&:hover": {
      backgroundColor: theme.palette.mode === "light" ? "#F6F9FD" : "#2B3033",
    },
  };
});

interface DashboardCardProps extends MuiCardProps {
  icon: React.ReactNode;
  title: string;
  content: string;
  onClick?: () => void;
}

export const DashboardCard: React.FC<DashboardCardProps> = ({
  icon,
  title,
  content,
  onClick,
  ...props
}) => {
  return (
    <StyledCard onClick={onClick} {...props}>
      <Box mb="1rem">{icon}</Box>
      <div>
        <Typography fontSize="1rem" fontWeight={600} component="h4" mb={1}>
          {title}
        </Typography>
        <Typography variant="body2">{content}</Typography>
      </div>
    </StyledCard>
  );
};

export default DashboardCard;
